import { useEffect, useState } from 'react'

// False during server rendering and the first client render, true afterwards.
export const useMounted = (): boolean => {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return mounted
}
